import axios, { AxiosResponse } from 'axios';
import store from '../store/store';

const axiosAgentInstance = axios.create({
  timeout: 15000,
  withCredentials: false,
});

const agentURL = process.env.VUE_APP_AGENT_SERVER;

export async function checkAgentAliveStatus(): Promise<boolean> {
  try {
    const response = await axiosAgentInstance.get(`${agentURL}/analysis`);
    store.commit('setAgentAliveStatus', response.data.alive);
    return response.data.alive;
  } catch (error) {
    console.error('에이전트의 상태를 확인할 수 없습니다.', error);
    store.commit('setAgentAliveStatus', false);
    return false;
  }
}

export async function requestDatasetFileAnalysis(
  datasetId: string,
  skipMetadata?: boolean,
): Promise<AxiosResponse<any>> {
  if (!(await checkAgentAliveStatus()))
    throw new Error('Agent server is not alive');

  return await axiosAgentInstance.post(`${agentURL}/analysis/file`, {
    datasetId: datasetId,
    skipMetadata,
  });
}

export async function requestLabelsetAnalysis(
  labelsetId: string,
): Promise<AxiosResponse<any>> {
  if (!(await checkAgentAliveStatus()))
    throw new Error('Agent server is not alive');

  return await axiosAgentInstance.post(`${agentURL}/analysis/newLabel`, {
    labelsetId: labelsetId,
  });
}

export async function getLabelsetStructure(
  labelType: string,
  targetPath: string,
  sourceFile?: string,
  ignoreList?: string,
): Promise<AxiosResponse<any>> {
  if (!(await checkAgentAliveStatus()))
    throw new Error('Agent server is not alive');

  return await axiosAgentInstance.get(`${agentURL}/analysis/structure`, {
    params: { labelType, targetPath, sourceFile, ignoreList },
    timeout: 0,
  });
}

export async function requestSchemaAnalysis(
  labelsetId: string,
): Promise<AxiosResponse<any>> {
  if (!(await checkAgentAliveStatus()))
    throw new Error('Agent server is not alive');

  return await axiosAgentInstance.post(`${agentURL}/analysis/schema`, {
    labelsetId: labelsetId,
  });
}

export async function downloadLocalData(
  path: string,
  type: 'image',
): Promise<string | null> {
  if (!(await checkAgentAliveStatus()))
    throw new Error('Agent server is not alive');

  try {
    const response = await axiosAgentInstance.post(
      `${agentURL}/files`,
      {
        path: path,
        type: type,
      },
      {
        responseType: 'blob',
      },
    );

    return window.URL.createObjectURL(response.data);
  } catch (error) {
    console.error(error);
    return null;
  }
}
